import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

// A custom theme for this app
const theme = createTheme({
  spacing: 5,
  typography: {
    button: {
      textTransform: 'none',
    },
    fontFamily: ['JINS Next', 'Noto Sans JP', 'sans-serif'].join(','),
  },
  palette: {
    primary: {
      main: '#37455D',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
